import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "ID", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Tên vật tư", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center justify-content-end" }, "SL Tồn", -1)
const _hoisted_4 = { class: "mb-0 text-end d-flex align-items-center justify-content-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center justify-content-end" }, "SL Xuất", -1)
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_7 = { class: "me-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "break-word mb-0 d-flex align-items-center justify-content-end" }, " SL còn phải xuất ", -1)
const _hoisted_9 = { class: "mb-0 text-end d-flex align-items-center justify-content-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_11 = { class: "text-end mb-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word d-flex align-items-center justify-content-end" }, "Thành tiền", -1)
const _hoisted_13 = { class: "mb-0 break-word d-flex align-items-center justify-content-end" }
const _hoisted_14 = {
  key: 0,
  class: "mt-5 d-flex justify-content-center pe-10 align-items-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "pe-5 pt-1" }, "Tổng cộng:", -1)
const _hoisted_16 = { style: {"width":"20%"} }
const _hoisted_17 = { class: "mt-5 d-flex justify-content-end pe-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_button_custom = _resolveComponent("button-custom")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      "cell-class-name": _ctx.isTextDangerColumn,
      data: _ctx.vatTuItemsComputed,
      "scrollbar-always-on": true,
      border: true,
      "empty-text": "Kho hiện tại không có vật tư tương ứng",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "50"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.$index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          property: "id",
          width: "60"
        }, {
          header: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          property: "ten_vat_tu",
          width: "200"
        }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_vat_tu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "MVT",
          property: "ma_vat_tu",
          width: "70"
        }),
        _createVNode(_component_el_table_column, {
          label: "ĐVT",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : "-"), 1)
          ]),
          _: 1
        }),
        (_ctx.selectingKhoItem)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: "70"
            }, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.quantityData[scope.$index]?.so_luong_trong_kho_ban_dau || 0), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.selectingKhoItem)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              width: "140"
            }, {
              header: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx((scope) => [
                (
            _ctx.quantityData[scope.$index] &&
            _ctx.quantityData[scope.$index].so_luong_trong_kho_ban_dau > 0 &&
            _ctx.vatTuSelectedInKho[_ctx.indexConvert(scope.$index)].con_thieu > 0
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_input_number, {
                        style: {"width":"100%"},
                        type: "number",
                        min: 0,
                        modelValue: _ctx.quantityData[scope.$index].so_luong_se_lay,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.quantityData[scope.$index].so_luong_se_lay) = $event),
                        onBlur: (value) => _ctx.onQuantityGettingChangeHandler(scope.$index, value),
                        onChange: (value) => _ctx.onQuantityGettingChangeHandler(scope.$index, value),
                        onFocus: _cache[0] || (_cache[0] = ($event: any) => ($event.target.select()))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange"])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.quantityData[scope.$index]?.so_luong_trong_kho_ban_dau) + " / ", 1),
                      _createElementVNode("span", {
                        class: _normalizeClass({
              'text-danger':
                _ctx.vatTuSelectedInKho[_ctx.indexConvert(scope.$index)].con_thieu > 0,
            })
                      }, "- / " + _toDisplayString(_ctx.vatTuSelectedInKho[_ctx.indexConvert(scope.$index)].con_thieu), 3),
                      _createElementVNode("span", null, [
                        _createVNode(_component_el_tooltip, {
                          class: "box-item ms-2",
                          effect: "dark",
                          content: "TSố lượng tổng trong kho / số lượng sẽ xuất / Số lượng còn lại\n              phải xuất",
                          placement: "top-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_InfoFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ], 64))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          width: _ctx.selectingKhoItem ? 80 : 130
        }, {
          header: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.calcRemainingNeed(scope.$index)), 1)
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, { label: "Đơn giá" }, {
          header: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.selectingKhoItem ? _ctx.formatCurrencyAndQuantity(scope.row.don_gia) : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "130" }, {
          header: _withCtx(() => [
            _hoisted_12
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.selectingKhoItem ? _ctx.thanhTienCalc(scope.$index, scope.row.don_gia, false) : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "50" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_button_custom, {
              "color-type": _ctx.ButtonTypeColors.INFO,
              "button-type": _ctx.ButtonsType.INFO,
              onClick: ($event: any) => (_ctx.detailButtonClickedHandler(scope.row.id, scope.$index))
            }, null, 8, ["color-type", "button-type", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["cell-class-name", "data"]),
    (_ctx.selectingKhoItem && _ctx.selectingKhoItem?.id >= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_input, {
              readonly: "",
              disabled: "",
              modelValue: _ctx.totalPrice,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.totalPrice) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_button_custom, {
        "color-type": _ctx.ButtonTypeColors.DANGER,
        "button-type": _ctx.ButtonsType.TRASH,
        onClick: _ctx.clearQuantityDataClickedHandler
      }, null, 8, ["color-type", "button-type", "onClick"]),
      (_ctx.selectingKhoItem && _ctx.selectingKhoItem.id >= 0 && !_ctx.isGettingAllSupplies)
        ? (_openBlock(), _createBlock(_component_button_custom, {
            key: 0,
            "color-type": _ctx.ButtonTypeColors.SUCCESS,
            "button-type": _ctx.ButtonsType.FORWARD,
            onClick: _ctx.nextButtonClickedHandler
          }, null, 8, ["color-type", "button-type", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}